import api, { ResponseCallback } from '../services/api.service'
import routeUtil from '../utils/route.util'
import { UnitData } from './unit.api'
import { UserData } from './user.api'

export interface CategoryData {
  id: number
  siteId: number
  unitId: number
  createdBy: number
  updatedBy: number
  deletedBy?: number
  name: string
  deletedAt?: string
  createdAt: string
  updatedAt: string
  itemsCount: number
  isDeleted: boolean
  unit?: UnitData
  updatedUser?: UserData
}

export interface CategoryCreateRequest {
  category?: string
  type?: number
}

export type CategoryUpdateRequest = CategoryCreateRequest

const routes = {
  list: '/categories',
  delete: '/categories/{id}',
  create: '/categories',
  read: '/categories/{id}',
  update: '/categories/{id}',
  adminSearch: '/admin/categories/search/{term}',
  search: '/categories/search/{term}'
}

export default {
  adminSearch(term: String, callback: ResponseCallback<CategoryData[]>){
    const url = routeUtil.replaceParams(routes.adminSearch, { term })
    api.get(url, {}, callback)
  },

  search(term: String, callback: ResponseCallback<CategoryData[]>){
    const url = routeUtil.replaceParams(routes.search, { term })
    api.get(url, {}, callback)
  },

  list (callback: ResponseCallback<CategoryData[]>) {
    api.get(routes.list, {}, callback)
  },

  delete (id: number, callback: ResponseCallback<CategoryData>) {
    const url = routeUtil.replaceParams(routes.delete, { id })
    api.delete(url, {}, callback)
  },

  create (
    payload: CategoryCreateRequest,
    callback: ResponseCallback<CategoryData>
  ) {
    api.post(routes.create, payload, callback)
  },

  read (id: number, callback: ResponseCallback<CategoryData>) {
    const url = routeUtil.replaceParams(routes.read, { id })
    api.get(url, {}, callback)
  },

  update (
    id: number,
    payload: CategoryUpdateRequest,
    callback: ResponseCallback<CategoryData>
  ) {
    const url = routeUtil.replaceParams(routes.update, { id })
    api.patch(url, payload, callback)
  }
}
